import axios from 'axios';
import AxiosBase from '@/auth/axiosBase';
const baseUrl = process.env.VUE_APP_BACKEND_URL;
export default class AppNavBarService extends AxiosBase {
    constructor() {
        super();
    }

    async RolDegistir(roleDto) {


        let processResult = "";
        const url = `${baseUrl}/api/Identity/Account/RolDegistir`;
        let requestBody = JSON.stringify(roleDto);
        await axios.post(url, requestBody)
            .then((response) => {
                processResult = response;

            }).catch((error) => {
                console.log(error);
            });

        return processResult;
    }


    async OgrencilikDegistir(roleDto) {


        let processResult = "";
        const url = `${baseUrl}/api/Identity/Account/OgrencilikDegistir`;
        let requestBody = JSON.stringify(roleDto);
        await axios.post(url, requestBody)
            .then((response) => {
                processResult = response;

            }).catch((error) => {
                console.log(error);
            });

        return processResult;
    }
    async GetOgrenciPhoto() {
        let result = {};
        const url = `${baseUrl}/api/Identity/Account/GetOgrenciPhoto`;
        await axios.get(url)
            .then((response) => {
                result = "data:image/jpeg;base64," + response.data.responseData;

                return result;
            }).catch((error) => {
                console.log(error);
            });
        return result;
    }
    async GetPersonelPhoto() {
        let result = {};
        const url = `${baseUrl}/api/Identity/Account/GetPersonelPhoto`;
        await axios.get(url)
            .then((response) => {
                result = "data:image/jpeg;base64," + response.data.responseData;
                return result;
            }).catch((error) => {
                console.log(error);
            });
        return result;
    }
}